import { campoDeveSerMaiorIgualCampo, campoDeveSerMaiorQueZero, campoDeveSerMenorIgualCampo, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosTipologia = {
  descricao: string
  quantidadeUnidades: string | number
  quantidadePermutas: string | number
  areaLote: string | number
  areaCasa: string | number
  tipologiaCasas: string | number
  perimetroMuroPorLote: string | number
  areaServicoExterna: string | number
  precoTabela: string | number
}

export const dadosTipologiaValorDefault = {
  descricao: '',
  quantidadeUnidades: '',
  quantidadePermutas: '',
  areaLote: '',
  areaCasa: '',
  tipologiaCasas: '',
  perimetroMuroPorLote: '',
  areaServicoExterna: '',
  precoTabela: ''
} as DadosTipologia

export class ValidacaoDadosTipologia {
  descricao: string
  quantidadeUnidades: string
  quantidadePermutas: string
  areaLote: string
  areaCasa: string
  tipologiaCasas: string
  perimetroMuroPorLote: string
  areaServicoExterna: string
  precoTabela: string

  constructor(
    descricao = '',
    quantidadeUnidades = '',
    quantidadePermutas = '',
    areaLote = '',
    areaCasa = '',
    tipologiaCasas = '',
    perimetroMuroPorLote = '',
    areaServicoExterna = '',
    precoTabela = ''
  ) {
    this.descricao = descricao
    this.quantidadeUnidades = quantidadeUnidades
    this.quantidadePermutas = quantidadePermutas
    this.areaLote = areaLote
    this.areaCasa = areaCasa
    this.tipologiaCasas = tipologiaCasas
    this.perimetroMuroPorLote = perimetroMuroPorLote
    this.areaServicoExterna = areaServicoExterna
    this.precoTabela = precoTabela
  }

  validarInputUsuario(inputUsuario: string): string {
    let error = ''

    if (parseFloat(inputUsuario) === 0) error = campoDeveSerMaiorQueZero

    if (inputUsuario === '') error = campoObrigatorio

    return error
  }

  validarCampoMaiorQueZero(inputUsuario: string): string {
    let error = ''

    if (parseFloat(inputUsuario) === 0) error = campoDeveSerMaiorQueZero

    return error
  }

  validarQuantidadePermutas(inputQuantidadePermutas: string, inputQuantidadeUnidades: string): string {
    if (parseInt(inputQuantidadePermutas) === 0) return campoDeveSerMaiorQueZero

    if (parseInt(inputQuantidadePermutas) > parseInt(inputQuantidadeUnidades)) return `${campoDeveSerMenorIgualCampo} Quantidade Unidades.`

    return ''
  }

  validarQuantidadeUnidades(inputQuantidadeUnidades: string, inputQuantidadePermutas: string): string {
    if (parseInt(inputQuantidadeUnidades) === 0) return campoDeveSerMaiorQueZero

    if (inputQuantidadeUnidades === '') return campoObrigatorio

    if (parseInt(inputQuantidadeUnidades) < parseInt(inputQuantidadePermutas)) return `${campoDeveSerMaiorIgualCampo} Quantidade Permutas.`

    return ''
  }

  validarDescricao(inputUsuario: string): string {
    let error = ''

    if (inputUsuario === '') error = campoObrigatorio

    return error
  }
}
